import React, { useCallback, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import {
  setThemeColors,
  setGradientColors,
  setCancelCheque,
  setBankStatement,
  setExchangeSegment,
  setNomineeProofvalidate,
} from "../../designs/v1/redux/actions";
import { getCentralURL } from "../../config";

const DetectBrokerRekycMoveDevice = () => {
  const dispatch = useDispatch();
  const { brokerID, token, docName } = useParams();
  const history = useHistory();
  const location = useLocation();

  const getBaseURL = useCallback(() => {
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    };
    const URL = getCentralURL();
    axios
      .post(
        `${URL}/api/method/central_system.apis.broker.api.get_broker_details`,
        {
          broker_id: brokerID,
        },
        headers
      )
      .then((result) => {
        const { data } = result.data;
        window.sessionStorage.setItem("token", token);
        window.sessionStorage.setItem("broker_id", brokerID);
        window.sessionStorage.setItem("doc_name", docName);
        window.sessionStorage.setItem(
          "broker_name",
          data.broker_basic_detail.broker_name
        );
        window.sessionStorage.setItem(
          "portal_domain",
          data.broker_basic_detail.portal_domain
        );
        axios
          .get(
            data.broker_basic_detail.portal_domain +
            "/api/method/kyc_customizations.apis.kyc_page.api.get_broker_setup_settings"
          )
          .then((result1) => {
            window.sessionStorage.setItem(
              "favicon",
              result1.data.data?.favicon
            );
            window.sessionStorage.setItem("logo", result1.data.data.logo);
            window.sessionStorage.setItem(
              "is_nomination_det_req",
              result1.data.data.is_nomination_det_req
            );
            window.sessionStorage.setItem(
              "theme_color_pallate",
              JSON.stringify(result1.data.data.theme_color_pallate)
            );
            window.sessionStorage.setItem(
              "joint_holder",
              result1.data.data.joint_holder
            );
            window.sessionStorage.setItem(
              "other_as_occupation",
              JSON.stringify(result1.data.data.other_as_occupation)
            );
            window.sessionStorage.setItem(
              "theme_landing_image",
              result1.data.data.theme_landing_image
            );
            window.sessionStorage.setItem(
              "gradientColor",
              JSON.stringify(result1.data.data.gradientColor)
            );
            result1.data?.data?.cancel_cheque_mandatory &&
              window.sessionStorage.setItem(
                "cancel_cheque_mandatory",
                JSON.stringify(result1.data?.data?.cancel_cheque_mandatory)
              );
            result1.data?.data?.statement_passbook_mandatory &&
              window.sessionStorage.setItem(
                "statement_passbook_mandatory",
                JSON.stringify(result1.data?.data?.statement_passbook_mandatory)
              );
            result1.data?.data?.is_nominee_address_proof_document_required &&
              window.sessionStorage.setItem(
                "hasNomineeProofValidate",
                JSON.stringify(
                  result1.data?.data?.is_nominee_address_proof_document_required
                )
              );
            result1.data?.data?.isReactivationProof &&
              window.sessionStorage.setItem(
                "hasReactivationProof",
                JSON.stringify(result1.data?.data?.isReactivationProof)
              );
            result1.data?.data?.account_closure_screen &&
              window.sessionStorage.setItem(
                "accountClosureScreen",
                JSON.stringify(result1.data?.data?.account_closure_screen)
              );
            result1.data?.data?.exchange_segment_v2 &&
              window.sessionStorage.setItem(
                "exchangeSegment",
                JSON.stringify(result1.data?.data?.exchange_segment_v2)
              );
            dispatch(setThemeColors(result1.data.data.theme_color_pallate));
            dispatch(setGradientColors(result1.data.data.gradientColor));
            dispatch(
              setCancelCheque(result1.data?.data?.cancel_cheque_mandatory)
            );
            dispatch(
              setBankStatement(result1.data?.data?.statement_passbook_mandatory)
            );
            dispatch(
              setNomineeProofvalidate(
                result1.data?.data
                  ?.is_nominee_address_proof_document_required || "No"
              )
            );
            dispatch(setExchangeSegment(result1.data.data.exchange_segment_v2));
            sessionStorage.setItem(
              "user",
              JSON.stringify({ type: "phone", entity: "" })
            );
            history.push(`/modify-kyc/${brokerID}`);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [dispatch, history, brokerID, token, docName]);

  useEffect(() => {
    sessionStorage.clear();
    sessionStorage.removeItem("modifyKYC");
    sessionStorage.removeItem("closeKYC");
    const pathName = location.pathname.split("/");
    if (pathName?.[1] === "m") {
      sessionStorage.setItem("modifyKYC", true);
    }
  }, [location]);

  useEffect(() => {
    getBaseURL();
  }, [getBaseURL]);

  return (
    <div className="flex h-100 justify-center align-center flex-column">
      <div className="mt-5">
        <Spinner animation="grow" />
      </div>
      <div>Please Wait...</div>
    </div>
  );
};

export default DetectBrokerRekycMoveDevice;
